// Getting if product is on sale
const isSaleItem = document.currentScript.getAttribute('isSaleItem');

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.form.querySelector('[name=id]').disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        const giftCheckbox = document.querySelector('input[name="properties[Packaging]"]:checked');
        const giftMessage = document.querySelector('#giftmessageoption textarea');

        if (giftCheckbox) {
          if (giftCheckbox.value === 'Lighter-Touch' && formData.has('properties[Gift Message]')) {
            formData.delete('properties[Gift Message]');
          }

          giftToggle();
        }

        if (giftMessage) {
          giftMessage.value = '';
        }

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // Calling a add gift wrap function if the item has gift wrap
            if (formData.get('properties[Packaging]') == 'Paid Gift Box') {
              // Sending in the quantity of the item being added
              this.addGiftWrap(formData.get('quantity'));
            }

            // Add personalisation charge if enabled and configured
            if (PersonalisationUtils.hasPersonalisationText(formData)) {
              const personalisationValue =
                formData.get('properties[Text]') ||
                formData.get('properties[Personalisation Text]') ||
                '';

              this.addPersonalisationCharge(
                formData.get('quantity'),
                formData.get('id'),
                response.key,
                PersonalisationUtils.countSerializedPersonalisationUnits(personalisationValue)
              );
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }

            gtmPushAddToCart();
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      // Takes the item quantity and builds a fetch request to add the gift wrap
      // as well
      addGiftWrap(quantity) {
        const giftWrapID = '53677135135105';
        // Building the body of the fetch request
        let body = JSON.stringify({
          items: [
            {
              id: giftWrapID,
              quantity: parseInt(quantity),
            },
          ],
        });
        // Firing the fetch request to add the gift wrap
        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.json();
          })
          .catch((error) => {
            console.error('Error:', error);
          });
      }

      addPersonalisationCharge(quantity, parentVariantId, parentLineKey, personalisationUnits) {
        const drawer = document.getElementById('PersonalisationDrawer');
        if (!drawer) return;

        // Only proceed if charge is enabled in settings
        if (drawer.dataset.enableCharge !== 'true') return;

        const variantId = drawer.dataset.chargeVariantId;
        if (!variantId) return;

        const units = Number.parseInt(personalisationUnits, 10);
        if (!Number.isInteger(units) || units < 1) return;
        const feeQuantity = PersonalisationUtils.calculatePersonalisationFeeQuantity(quantity, units);

        let body = JSON.stringify({
          items: [
            {
              id: variantId,
              quantity: feeQuantity,
              properties: {
                '_personalisation_fee': 'true',
                '_parent_id': String(parentVariantId || ''),
                '_parent_key': String(parentLineKey || ''),
                '_personalisation_units': String(units),
              },
            },
          ],
        });
        fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => response.json())
          .catch((error) => console.error('Error adding personalisation charge:', error));
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}

// Moving the toggle of the text area to the js file
function giftToggle() {
  const giftArea = document.getElementById('gift-area');
  const gwSelector = giftArea.querySelector('input[name="properties[Packaging]"]:checked');
  const gwMessage = giftArea.querySelector('#giftmessageoption');
  const gwSelect = giftArea.querySelector('#giftmessageselect');
  const gwInfo = giftArea.querySelector('#giftmessageinfo');

  if (!gwSelector || !gwMessage || !gwSelect) {
    return;
  }

  if (gwSelector.value == 'Gift Box' || gwSelector.value == 'Paid Gift Box') {
    gwMessage.classList.remove('tw-hidden');
    gwMessage.classList.add('tw-flex');

    if (!isSaleItem) {
      gwInfo.classList.add('tw-hidden');
      gwInfo.classList.remove('tw-flex');
    }
  } else {
    gwMessage.classList.remove('tw-flex');
    gwMessage.classList.add('tw-hidden');

    if (!isSaleItem) {
      gwInfo.classList.remove('tw-hidden');
      gwInfo.classList.add('tw-flex');
    }
  }
}

function gtmPushAddToCart() {
  const dataLayer = window.dataLayer || [];

  dataLayer.push({
    event: 'cs_add_to_cart',
  });
}
